import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';


export const getAllHunters = async (token: string) => {
  try {
    const response = await axios.get(`${API_URL}/hunter/get-all`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in getAllHunters:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const getAllHuntersNotLinked = async (token: string) => {
  try {
    const response = await axios.get(`${API_URL}/hunter/get-all-not-linked`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in getAllHuntersNotLinked:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const getHunterById = async (id: string) => {
  try {
    const token = localStorage.getItem("authToken")
    if (!token) {
      throw new Error("No authentication token found")
    }

    const response = await axios.get(`${API_URL}/hunter/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error: any) {
    console.error("Error in getHunterById:", error)
    handleAuthError(error)
    return undefined
  }
}

export const getAllHunterProperties = async (token: string) => {
  try {
    const response = await axios.get(`${API_URL}/hunterproperty/get-all`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in getAllHunterProperties:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const getAllHunterAssignedProperties = async (token: string) => {
  try {
    const response = await axios.get(`${API_URL}/hunterproperty/get-all-by-assigned`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in getAllHunterAssignedProperties:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const getHunterProperties = async (token: string) => {
  try {
    const response = await axios.get(`${API_URL}/hunterproperty/get-by-hunter-id`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in getHunterProperties:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const getPropertyCountersByHunterAssigned = async (token: string) => {
  try {
    const response = await axios.get(`${API_URL}/hunterproperty/get-property-counters-by-hunter-assigned`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in getPropertyCountersByHunterAssigned:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const getPropertyCountersByHunterId = async (hunterId: number, token: string) => {
  try {
    const response = await axios.get(`${API_URL}/hunterproperty/get-property-counters/${hunterId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in getPropertyCountersByHunterId:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const updateHunter = async (propertyId: number, hunterId: number, token: string) => {
  try {
    const formData = new FormData();
    formData.append('HunterPropertyId', propertyId.toString());
    formData.append('HunterId', hunterId.toString());

    const response = await axios.post(`${API_URL}/hunterproperty/update-hunter`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in updateHunter:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const updateStatus = async (propertyId: number, moduleStateId: number, token: string) => {
  try {
    const formData = new FormData();
    formData.append('HunterPropertyId', propertyId.toString());
    formData.append('HunterPropertyModuleStateId', moduleStateId.toString());

    const response = await axios.post(`${API_URL}/hunterproperty/update-status`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in updateStatus:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const deleteHunterProperty = async (propertyId: number, token: string) => {
  try {
    const formData = new FormData();
    formData.append('PropertyId', propertyId.toString());

    const response = await axios.post(`${API_URL}/hunterproperty/delete-hunter-property`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    
    return response.data;
  } catch (error: any) {
    console.error("Error in deleteHunterProperty:", error);
    handleAuthError(error);
    return undefined;
  }
};

const handleAuthError = (error: any) => {
  if (error.response) {
    throw new Error(error.response.data.message || error.message); 
  } else {
    throw new Error(error.message || 'An unknown error occurred');
  }
};